// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 792 ? "main" : chunkId) + "." + {"218":"bf3f8789c6c628aa4bae","271":"b02dfe9e84c61e6082a5","792":"e90b1f62ad1ab35762cf","936":"734b20a5c033e7a6250d"}[chunkId] + ".css";
};